import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenewalsGridComponent } from './components/renewals-grid/renewals-grid.component';
import { RenewalsIndexComponent } from './pages/renewals-index/renewals-index.component';
import { RenewalsJourneyComponent } from './pages/renewals-journey/renewals-journey.component';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { ExcelModule, GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { RenewalsSharedRoutingModule } from './renewals-shared-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { ErrorDialogComponent } from './pages/renewals-journey/error-dialog/error-dialog.component';

@NgModule({
  declarations: [
    RenewalsIndexComponent,
    RenewalsJourneyComponent,
    RenewalsGridComponent,
    ErrorDialogComponent,
],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    GridModule,
    ExcelModule,
    PDFModule,
    ExcelExportModule,
    RenewalsSharedRoutingModule,
    MatButtonModule 
  ],
  providers: []
})
export class RenewalsSharedModule { }
